import { useEffect, useState } from "react";
import { FormikProvider, useFormik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { config } from "../../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import allowNumbersOnly from "../../CommonUtils/CommonValidations";
// import allowNumbersOnly from "../../CommonUtils/CommonValidations";

function LaboratoriesInspection() {
  const [labData, setLabData] = useState(false);
  const [courseData, setCourseData] = useState(false);

  // ******** VALIDATION ********
  const validation = Yup.object().shape({
    labDetails: Yup.array().of(
      Yup.object().shape({
        totalLabs: Yup.string().required("Required"),
        suffEquLabs: Yup.string().required("Required"),
        insuffEquLabs: Yup.string().required("Required"),
      }),
    ),
  });
  // ******** FORMIK ********
  const labFormik = useFormik({
    initialValues: {
      labDetails: [],
    },
    validationSchema: validation,
    onSubmit: (values) => {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to Save ?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
      }).then((result) => {
        if (result.isConfirmed) {
          const payload = {
            labDetails: values.labDetails.map((item) => ({
              courseId: parseInt(item.courseId, 10),
              totalLabs: parseInt(item.totalLabs),
              suffEquLabs: parseInt(item.suffEquLabs),
              insuffEquLabs: parseInt(item.insuffEquLabs),
            })),
          };
          const url = `${config.url.FAC_URL}saveLabDetails`;
          CommonAxiosPost(url, payload)
            .then((res) => {
              if (res?.data?.scode === "01") {
                Swal.fire({
                  title: res.data.sdesc || "Saved!",
                  icon: "success",
                }).then(() => {
                  LoadData();
                });
              } else {
                Swal.fire({
                  text: res.data?.sdesc || "Failed to save details",
                  icon: "warning",
                });
              }
            })
            .catch((err) => {
              console.error(err);
              Swal.fire({
                text: "An error occurred during submission.",
                icon: "error",
              });
            });
        }
      });
    },
  });

  // ******** LOAD DATA ********
  function LoadData() {
    // -------- COURSE DATA --------
    let courseUrl = `${config.url.FAC_URL}getCourseIntakeList`;
    CommonAxiosGet(courseUrl).then((courseRes) => {
      let courses = [];
      if (courseRes?.data?.scode === "01") {
        setCourseData(true);
        courses = courseRes?.data?.list || [];
      }

      // -------- LAB DATA --------
      let labUrl = config.url.FAC_URL + `getLabDetails`;
      CommonAxiosGet(labUrl).then((labRes) => {
        let labData = [];
        if (labRes?.data?.scode === "01") {
          (setLabData(true), (labData = labRes?.data?.data || []));
        }

        // -------- MERGE --------
        const mappedData = courses.map((course) => {
          const existingLab = labData.find(
            (lab) => lab.course_id === course.course_id,
          );
          return {
            courseId: course.course_id,
            courseName: course.course_name,
            courseCatId: course.course_cat_id,
            courseCatName: course.course_cat_name,
            courseGroupCode: course.course_group_code,
            courseGroupName: course.course_group_desc,
            totalLabs: existingLab ? existingLab.total_labs : "",
            suffEquLabs: existingLab ? existingLab.suff_equipment_labs : "",
            insuffEquLabs: existingLab ? existingLab.insuff_equipment_labs : "",
          };
        });
        // Always set rows
        labFormik.setFieldValue("labDetails", mappedData);
      });
    });
  }

  // ******** LOAD ON START ********
  useEffect(() => {
    LoadData();
  }, []);

  return (
    <div className="faculty-form-wrapper">
      <div className="faculty-card">
        <h5 className="mb-3 innerheader-new">
          <span>Laboratories: For the proposed intake</span>
        </h5>

        <FormikProvider value={labFormik}>
          <Form onSubmit={labFormik.handleSubmit} className="affl-form">
            {courseData ? (
              <>
                <div className="table-responsive mt-3">
                  <table className="table table-bordered mt-2">
                    <thead className="table-primary">
                      <tr>
                        <th style={{ width: "5%" }}>SNO</th>
                        <th style={{ width: "15%" }}>
                          {" "}
                          Academic Program Type{" "}
                        </th>
                        <th style={{ width: "15%" }}>Course / Program </th>
                        <th style={{ width: "15%" }}> Course / Branch </th>
                        <th style={{ width: "15%" }}>
                          Total No. of 1st Year Laboratories
                        </th>
                        <th style={{ width: "15%" }}>
                          Total No. of Laboratories with sufficient equipment to
                          conduct 100% experiments as per syllabus in 1st
                          year{" "}
                        </th>
                        <th style={{ width: "15%" }}>
                          Total No. of Laboratories with Insufficient equipment
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {labFormik.values.labDetails.map((row, index) => (
                        <tr key={row.courseId || index}>
                          <td>{index + 1}</td>
                          <td>
                            {row.courseGroupName}
                            <Field
                              type="hidden"
                              name={`labDetails[${index}].courseGroupCode`}
                            />
                            <Field
                              type="hidden"
                              name={`labDetails[${index}].courseGroupName`}
                            />
                          </td>
                          <td>
                            {row.courseCatName}
                            <Field
                              type="hidden"
                              name={`labDetails[${index}].courseCatId`}
                            />
                            <Field
                              type="hidden"
                              name={`labDetails[${index}].courseCatName`}
                            />
                          </td>
                          <td>
                            {row.courseName}
                            <Field
                              type="hidden"
                              name={`labDetails[${index}].courseId`}
                            />
                            <Field
                              type="hidden"
                              name={`labDetails[${index}].courseName`}
                            />
                          </td>
                          <td>
                            <Field
                              type="text"
                              className="form-control"
                              name={`labDetails[${index}].totalLabs`}
                              onKeyPress={allowNumbersOnly}
                              disabled={labData}
                              maxLength="3"
                            />
                            <ErrorMessage
                              name={`labDetails[${index}].totalLabs`}
                              component="div"
                              className="text-danger small"
                            />
                          </td>
                          <td>
                            <Field
                              type="text"
                              className="form-control"
                              name={`labDetails[${index}].suffEquLabs`}
                              onKeyPress={allowNumbersOnly}
                              disabled={labData}
                              maxLength="3"
                            />
                            <ErrorMessage
                              name={`labDetails[${index}].suffEquLabs`}
                              component="div"
                              className="text-danger small"
                            />
                          </td>
                          <td>
                            <Field
                              type="text"
                              className="form-control"
                              name={`labDetails[${index}].insuffEquLabs`}
                              onKeyPress={allowNumbersOnly}
                              disabled={labData}
                              maxLength="3"
                            />
                            <ErrorMessage
                              name={`labDetails[${index}].insuffEquLabs`}
                              component="div"
                              className="text-danger small"
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {!labData ? (
                  <button
                    type="submit"
                    className="btn btn-primary float-end mt-3"
                  >
                    {" "}
                    Submit{" "}
                  </button>
                ) : (
                  <div className="d-flex justify-content-end mt-4">
                    <span className="text-success fw-bold">
                      Already Submitted
                    </span>
                  </div>
                )}
              </>
            ) : (
              <div className="text-center text-danger fw-bold fs-6">
                **** No Data Found ****
              </div>
            )}
          </Form>
        </FormikProvider>
      </div>
    </div>
  );
}
export default LaboratoriesInspection;
